const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const GroupActions = Reflux.createActions({
    getGroups: { children: ["started", "completed", "failed"] },
    createGroup: { children: ["completed", "failed"] },
    archiveGroup: { children: ["completed", "failed"] },
    renameGroup: { children: ["completed", "failed"] },
    getGroupUsers: { children: ["started", "completed", "failed"] },
    inviteGroupUser: { children: ["completed", "failed"] },
    removeGroupUser: { children: ["completed", "failed"] },
});

GroupActions.getGroups.listen(function(actionId) {
    this.started(actionId);
    ServerRequest.makeRequest('/authoring/groups', 'GET')
        .then(res => this.completed(actionId, res) )
        .catch(err => this.failed(actionId, err))
});

GroupActions.createGroup.listen(function(actionId, params) {
    if (!params.name) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ["input"] }));
        return;
    }

    ServerRequest.makeRequest('/authoring/group/create', 'POST', JSON.stringify({
            name: params.name
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

GroupActions.archiveGroup.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/group/' + params.id + '/archive', 'POST')
        .then(res => this.completed(actionId, params.id, res))
        .catch(err => this.failed(actionId, params.id, err));
});

GroupActions.renameGroup.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/group/' + params.id + '/rename', 'POST', JSON.stringify({
            name: params.name
        }))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, err));
});

GroupActions.getGroupUsers.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/group/' + params.id + '/users', 'GET')
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

GroupActions.inviteGroupUser.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/group/' + params.group_id + '/invite', 'POST', JSON.stringify({
            email: params.email
        }))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

GroupActions.removeGroupUser.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/group/' + params.group_id + '/remove', 'POST', JSON.stringify({
            user_hash: params.user_hash
        }))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

module.exports = GroupActions;